<div class="growth-char-type-select-container" *ngIf="isVisible">
    <mat-radio-group class="options-radio-group" color="primary" [formControl]="selectionControl">
        <mat-radio-button
            *ngFor="let option of typeOptions"
            class="radio-option"
            [value]="option.id"
        >{{option.text}}</mat-radio-button>
    </mat-radio-group>
</div>